export class AssetLibraryConstants {
    static readonly SLASH = '/';
    static readonly SLASH_CUSTOM_HEROTILE = '/custom-herotiles';
    static readonly MAIN_TILE_IMAGE = 'heroTile';
    static readonly GAMING_IPOS_BANNER = 'gamingBanner';
    static readonly CUSTOM_TILE_GROUP = "CustomHeroTileGroup";

    static readonly ASSET_LIBRARY_USERS = '/asset-library/users/';
    static readonly ASSET_LIBRARY_PROFILES = '/asset-library/profiles/';
    static readonly S3_ASSET_LIBRARY_USERS = '/users/';
    static readonly S3_ASSET_LIBRARY_RETAILERS = '/retailers/';
    static readonly ASSET_LIBRARY_ASSET_LIBRARY = '/asset-library/asset-library-';
    static readonly LOGO_CONTENTS = '/logo-contents';
    static readonly STORE_LOGO = '/store-logos';
    static readonly PROMO_CONTENTS = '/promotional-contents';
    static readonly SRT_HERO_TILES = '/srtherotiles';
    static readonly SEGMENTS = '/segments';
    static readonly BANNER_CONTENTS = '/banner-carousels';
    static readonly CUSTOM_HEROTILES = '/custom-herotiles';
    static readonly PRICE_CONTENTS = '/price-contents';
    static readonly ATTRACTOR_LOOP = '/attract-loops';
    static readonly stdPkgURL = '/packagehandler/package/standard/';
    static readonly userType = 'user-type/';
    static readonly retID = '?retailer-id=';

    // Sort Order Key-Values
    static readonly SORT_ORDER_SEGMANT_NAME = 'segmentName';
    static readonly SORT_ORDER_SEGMANT_NAME_LABEL = $localize`:@@segments.sort-dropdown-segment.name:Segment Name`;
    static readonly SORT_ORDER_RETAILER_NAME = 'retailerName';
    static readonly SORT_ORDER_RETAILER_NAME_LABEL = $localize`:@@segments.sort-dropdown-retailer.name:Retailer Name`;
    static readonly HERO_TILE_PATH = '/heroTile';
    static readonly GAMING_BANNER_PATH = '/gamingBanner';   
    static readonly FALLBACK_EXE = '/fallbackExe'; 
    static readonly SELECT_RETAIL_HQ = $localize`:@@create-hero-tile.select-retailer:Select Retail HQ`;
    static readonly NEW_HERO_TILE_ASSET = 'NEW MAIN TILE ASSET';
    static readonly NEW_CUSTOM_HERO_TILE_ASSET = $localize`:@@ccustom-tile.asset-library.new-main-tile-content:NEW MAIN TILE CONTENT`;
    static readonly PUBLISHED_NAME_PLACEHOLDER = $localize`:@@global.tab-text.published-name:Published Name`;
    static readonly INTERNAL_NAME_PLACEHOLDER = $localize`:@@global.tab-text.internal-name:Internal Name`;
    static readonly CALL_TO_ACTION_PLACEHOLDER = $localize`:@@create-hero-tile.create-button:See all recommendations!`;
    static readonly ENTER_HEADLINE_PLACEHOLDER = $localize`:@@segments.enter-headline-placeholder:Enter Headline`;
    static readonly ENTER_SUB_HEADLINE_PLACEHOLDER = $localize`:@@segments.enter-sub-headline-placeholder:Enter Sub-headline`;
    static readonly ENTER_RETAILER_NAME_PLACEHOLDER = $localize`:@@segments.enter-retailer-name-placeholder:Enter Retailer Name`;
    static readonly COLOR_INFO_TOOLTIP = $localize`:@@segments.create-segment.color-info-tool-tip:To help with legibility pick a font color that will contrast with the Segment color.`;
    //lock content key values
    static readonly ACTIVE_STATUS = '?action='

    static readonly SEND_TO_RETAILER_ID = 'sent-to-store?retailerid=';
    static readonly CALL_TO_ACTION_CUSTOM_PLACEHOLDER = $localize`:@@ccustom-tile.asset-library.see-recommendations:See Recommendations`;
    static readonly CUSTOM_UPDATE_ERROR = $localize`:@@ccustom-tile.asset-library.custom-update-error:This content has been updated, share the latest version with the Retail HQ.`;
    static readonly CUSTOM_MAIN_TITLE_SUBTITLE = $localize`:@@ccustom-tile.asset-library.custom-main-tile-subtitle:You may show 1 Custom Main Tile Content, and you can add up to 3 Custom Main Tile Content Groups to the package.`;
    // custom tile 
}
